import React from "react";

interface MainContainerProps {
  children: React.ReactNode;
}

const MainContainer: React.FC<MainContainerProps> = ({ children }) => (
  <div className="min-h-screen bg-neutral-100">{children}</div>
);

export default MainContainer;
